export const DISABLED_TOOLTIP_TEXT = 'You don’t have permission for this action. Please get in touch with the company admin.';
